<template>
  <div class="popup_wrap hanger_apply_popup" style="width:760px; height:520px; overflow:none;">
    <button class="layer_close" @click="$emit('close')">close</button>

    <div class="popup_cont cod_cont_area">
      <h1 class="page_title">행거해체비 추가</h1>

      <div class="content_box">
        <div class="table_area">
          <table class="tbl_list font_sm gridtype hanger_table">
            <colgroup>
              <col width="8%">
              <col width="20%">
              <col width="30%">
              <col width="21%">
              <col width="21%">
            </colgroup>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    id="hanger_all_chk"
                    :checked="isAllChecked"
                    @change="toggleAll($event)"
                  >
                  <label for="hanger_all_chk"><span></span></label>
                </th>
                <th>B/L No.</th>
                <th>Container No.</th>
                <th>반납여부</th>
                <th>행거해체비</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(vo, idx) in list" :key="`${vo.blNo}_${vo.cntrNo}_${idx}`">
                <td class="text_center">
                  <input
                    type="checkbox"
                    :id="`hanger_chk_${idx}`"
                    :disabled="Number(vo.rtnY) === 1 || vo.hgUseYn === 'Y'"
                    :checked="isChecked(vo)"
                    @change="toggleRow(vo, $event)"
                  >
                  <label :for="`hanger_chk_${idx}`"><span></span></label>
                </td>
                <td>{{ vo.blNo }}</td>
                <td>{{ vo.cntrNo }}</td>
                <td>
                  <span :class="Number(vo.rtnY) === 1 ? 'status_blue' : 'status_gray'">
                    {{ Number(vo.rtnY) === 1 ? '반납완료' : '-' }}
                  </span>
                </td>
                <td>
                  <span :class="vo.hgUseYn === 'Y' ? 'status_blue' : 'status_gray'">
                    {{ vo.hgUseYn === 'Y' ? '추가완료' : '-' }}
                  </span>
                </td>
              </tr>

              <tr v-if="list.length === 0">
                <td colspan="5" class="empty_row">조회된 컨테이너가 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="guide_box">
          *반납 완료된 컨테이너의 경우 행거해체비 추가가 불가합니다.
        </div>

        <div class="btn_area">
          <a class="button blue lg" href="#" @click.prevent="confirmAdd">추가</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import calcIssue from '@/api/rest/settle/calcIssue'

export default {
  name: 'HangerApplyPop',
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          blNo: '',
          blNoList: []
        }
      }
    }
  },
  data () {
    return {
      list: [],
      checkedMap: {}
    }
  },
  computed: {
    selectableList () {
      return this.list.filter(row => Number(row.rtnY) !== 1 && row.hgUseYn !== 'Y')
    },
    isAllChecked () {
      if (this.selectableList.length === 0) return false
      return this.selectableList.every(row => this.checkedMap[this.makeKey(row)] === true)
    }
  },
  created () {
    this.initPop()
  },
  methods: {
    makeKey (row) {
      return `${row.blNo}_${row.cntrNo}`
    },

    isChecked (row) {
      return this.checkedMap[this.makeKey(row)] === true
    },

    toggleRow (row, event) {
      this.$set(this.checkedMap, this.makeKey(row), event.target.checked)
    },

    toggleAll (event) {
      const checked = event.target.checked
      this.selectableList.forEach(row => {
        this.$set(this.checkedMap, this.makeKey(row), checked)
      })
    },

    async initPop () {
      const info = this.parentInfo || {}

      if (
        this.$ekmtcCommon.isEmpty(info.blNo) &&
        (!info.blNoList || info.blNoList.length === 0)
      ) {
        const TH = this
        this.$ekmtcCommon.alertCallback('대상 B/L 정보가 없습니다.', () => {
          TH.$emit('close')
        })
        return
      }

      await this.loadList()
    },

    async loadList () {
      const parentInfo = this.parentInfo || {}
            const params = {
              blNo: parentInfo.blNo,
              blNoList: parentInfo.blNoList
            }
            try {
              const res = await calcIssue.getHangerTargetContainerList(params)
              this.list = (res.data || []).map(item => ({
                blNo: item.blNo,
                cntrNo: item.cntrNo,
                rtnY: item.rtnY,
                cntrSzCd: item.cntrSzCd,
                cntrTypCd: item.cntrTypCd,
                hgUseYn: item.hgUseYn
              }))
            } catch (e) {
              this.$ekmtcCommon.alert('행거 대상 컨테이너 조회 중 오류가 발생했습니다.')
            }
          },
      async confirmAdd () {
        const selectedList = this.list.filter(row => this.checkedMap[this.makeKey(row)] === true)
        console.log('1 selectedList', selectedList)
        console.log('1_2 selectedList', this.$ekmtcCommon.isEmpty(selectedList))
        console.log('1_3 selectedList', selectedList)
        console.log('1_4 selectedList', selectedList.length)

        if (this.$ekmtcCommon.isEmpty(selectedList) || (selectedList && selectedList.length === 0)) {
          this.$ekmtcCommon.asyncAlertMessage({ message: '선택한 컨테이너가 없습니다.' })
          return
        }
        const ok = await this.$ekmtcCommon.asyncAlertMessage({
          message: '선택한 컨테이너에 행거해체비를 추가하시겠습니까?',
          useConfirmBtn: true
        })

        console.log('2 ok', ok)

        if (!ok) return

        console.log('3 emit before')

        this.$emit('callback', {
          containerList: selectedList.map(row => ({
            blNo: row.blNo,
            cntrNo: row.cntrNo
          }))
        })
        console.log('4 emit after')
      }
    }
  }
</script>

<style scoped>

.hanger_apply_popup .content_box {
  height: auto !important;
  min-height: 0 !important;
  padding-top: 10px;
}

.table_area {
  width: 100%;
  height: auto !important;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid #d0d5dd;
  border-left: 1px solid #d0d5dd;
  border-right: 1px solid #d0d5dd;
  border-bottom: 0;  /* 변경: 이중선 제거 */
  background: #fff;
}

.hanger_table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  background: #fff;
}

.hanger_table thead th,
.hanger_table tbody td {
  height: 36px;
  padding: 0 10px;
  text-align: center;
  vertical-align: middle;
  border-top: 1px solid #d0d5dd;
  border-right: 1px solid#d0d5dd;
  border-bottom: 1px solid #d0d5dd;
  border-left: 1px solid #e5e7eb;
}

.hanger_table thead th {
  border-top: 0;
  background: #f8fafc;
  font-weight: 500;
}

.hanger_table thead th:first-child,
.hanger_table tbody td:first-child {
  border-left: 0;
}

.hanger_table thead th:last-child,
.hanger_table tbody td:last-child {
  border-right: 0;
}

.hanger_table,
.hanger_table * {
  border-radius: 0 !important;
}

.empty_row {
  text-align: center;
  color: #8a8f99;
}

.guide_box {
  margin-top: 14px;
  color: #8a8f99;
  font-weight: 400;
}

.btn_area {
  margin-top: 26px;
  text-align: center;
}

.return_badge {
  display: inline-block;
  margin-left: 8px;
  font-size: 12px;
  color: #d33;
  font-weight: 600;
}

.table_area::-webkit-scrollbar {
  width: 6px;
}

.table_area::-webkit-scrollbar-thumb {
  background: #d8dbe3;
  border-radius: 3px;
}

.text_center {
  text-align: center;
}

.status_red {
  color: #e53935;
  font-weight: 500;
}

.status_blue {
  color: #1565c0;
  font-weight: 500;
}

.status_gray {
  color: #8a8f99;
}

.hanger_table td label,
.hanger_table th label {
  display: inline-block;
  margin: 0;
  cursor: pointer;
}
</style>
